import compact from 'lodash/compact'

import { ROUTES } from 'constants/routes'
import { route } from 'utils/router'

export type ClientSection = {
  path: string
  label: string
}

export type ClientSectionGroup = {
  label: string
  sections: ClientSection[]
}

export type ClientSectionAccess = {
  canManageCustomDomain: boolean
  canViewClientFeatureGroups: boolean
  hasAmb: boolean
  isCommunityCSPClient: boolean
  isNotTwilio: boolean
}

export const OVERVIEW_SECTION: ClientSection = { path: ROUTES.CLIENT.OVERVIEW, label: 'Overview' }

export function getClientSectionGroups(access: ClientSectionAccess): ClientSectionGroup[] {
  const groups: ClientSectionGroup[] = [
    {
      label: 'Client',
      sections: [
        { path: ROUTES.CLIENT.GENERAL, label: 'General' },
        { path: ROUTES.CLIENT.MEMBERS_COMPLIANCE, label: 'Members & Compliance' },
        { path: ROUTES.CLIENT.SIGN_UP, label: 'Sign Up' },
        { path: ROUTES.CLIENT.TEAM, label: 'Team' },
      ],
    },
    {
      label: 'Messaging',
      sections: compact([
        { path: ROUTES.CLIENT.MESSAGES, label: 'Messages' },
        { path: ROUTES.CLIENT.KEYWORDS, label: 'Keywords' },
        { path: ROUTES.CLIENT.NUMBER_IMPORT, label: 'Number Import' },
        access.hasAmb && { path: ROUTES.CLIENT.AMB, label: 'AMB' },
      ]),
    },
    {
      label: 'Account',
      sections: compact([
        { path: ROUTES.CLIENT.BILLING, label: 'Billing' },
        access.canViewClientFeatureGroups && { path: ROUTES.CLIENT.FEATURE_GROUPS, label: 'Plans & Feature Groups' },
      ]),
    },
    {
      label: 'Infrastructure',
      sections: compact([
        access.isNotTwilio && { path: ROUTES.CLIENT.NUMBER_PROVISIONING, label: 'Number Provisioning' },
        access.isCommunityCSPClient && { path: ROUTES.CLIENT.TCR, label: 'TCR' },
        access.canManageCustomDomain && { path: ROUTES.CLIENT.CUSTOM_DOMAIN, label: 'Custom Domain' },
      ]),
    },
  ]

  return groups.filter((group) => group.sections.length > 0)
}

// The Overview path is a prefix of every other section path, so only an exact match selects it.
export function findActiveSection(
  pathname: string,
  clientId: string,
  sections: ClientSection[],
): ClientSection | undefined {
  return sections.find((section) => {
    const sectionPathname = route(section.path, { id: clientId })
    if (section.path === ROUTES.CLIENT.OVERVIEW) return pathname === sectionPathname
    return pathname === sectionPathname || pathname.startsWith(`${sectionPathname}/`)
  })
}
